import React from "react";
import { Button, Grid, IconButton,Tooltip } from "@mui/material";
import { FieldArray } from "formik";
import { FormikProps, FormikValues, useFormikContext } from "formik";
import { Add } from "@mui/icons-material";
import { IconX } from "@tabler/icons";
import { InputField } from "../../../../utils/FormFields";

const Allergies = () => {
  const formik: FormikProps<FormikValues> = useFormikContext();
  return (
    <>
      <FieldArray
        name="Patient.Allergies"
        render={(arrayHelpers) => (
          <>
            <Grid item xs={12} sx={{ textAlign: "right" }}>
              <Tooltip title="Add Allergy">
                <Button
                  onClick={() => {
                    arrayHelpers.push("");
                  }}
                  color="primary"
                  variant="outlined"
                  sx={{ p: 1, mb: 4 }}
                >
                  <Add />
                </Button>              
              </Tooltip>
            </Grid>
            <Grid container spacing={3}>
              {formik?.values?.Patient?.Allergies.map((note: string, index: number) => (
                <>
                  <Grid item xs={10} sm={5} md={3} key={"Allergy" + index}>
                    <InputField name={`Patient.Allergies[${index}]`} value={note} label="Allergy" />
                  </Grid>
                  <Grid item xs={1} sm={1}>
                    <Tooltip title="Remove Allergy">
                      <IconButton onClick={() => arrayHelpers.remove(index)}>
                        <IconX color="red" />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </>
              ))}
            </Grid>
          </>
        )}
      />
    </>
  );
};

export default Allergies;
